/*
 * @Author: Teemo Ding
 * @Date: 2021-08-19 13:55:06
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-19 13:56:29
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/logoManagement/index.ts
 */
import { get, post } from '@/src/tools/server';

export const getLogo = (salesChannelUuid) => {
  return get<any>(
    `/portal/salesChannelSetting/logoSetting/${salesChannelUuid}`,
    {},
  );
};

export const saveLogo = (body) => {
  return post<any>(`/portal/salesChannelSetting/logoSetting`, body, {});
};
